import actions from './actions';
import reducer from './reducer';
import selectors from './selectors';
import type { FossaSubscriptionPlan, FossaSubscriptionPlanPreview, AsyncStatus } from '../../types';

export type SubscriptionStore = {
  status: AsyncStatus
  subscription: FossaSubscriptionPlan | null;
  subscriptionPreview: FossaSubscriptionPlanPreview | null;
  canceled: boolean,
  updated: boolean,
};

export default { actions, reducer, selectors };
